import appConfiguration from "@/components/cfg/AppCfg";
import { Module } from "@/constants";
import { withToken } from "@/lib/url";
import { useEffect, useState } from "react";
const { apiUrl, apiVersion } = appConfiguration;

const FILE_NAME = "contest-agreements-confirmation.pdf";

export const useConsentAgreementFile = (token: string) => {
  const filePath = `${apiUrl}/${apiVersion}/${Module.ContestAgreements}/confirmation`;
  const fileUrl = withToken(filePath, token);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetch(fileUrl)
      .then(async (response) => {
        if (!response.ok) {
          setError(true);
        }
        const base64Content = await response.text();
        if (!cancelled) {
          setDataUrl(`data:application/pdf;base64,${base64Content}`);
          setLoading(false);
        }
      })
      .catch(() => {
        setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [fileUrl]);

  return {
    url: dataUrl,
    name: FILE_NAME,
    error,
    loading,
  };
};
